import styled from "styled-components";

export const Popup = styled.div`
  width: 920px;
  max-width: calc(100vw - 80px);
  height: 85vh;
  padding: 28px 28px 20px;
  box-sizing: border-box;
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 22px;
    font-weight: 700;
    line-height: normal;
  }

  > img {
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
`;

export const TableContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  .date {
    width: 14%;
  }
  .pub {
    width: 14%;
  }
  .nickname {
    width: 12%;
  }
  .ticket {
    width: 28%;
  }
  .type {
    width: 10%;
  }
  .count {
    width: 8%;
  }
  .memo {
    width: 14%;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 5px 16px;
  box-sizing: border-box;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #121212;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    text-align: center;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  flex: 1;
`;

export const TableItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  min-height: 48px;
  padding: 8px 16px;
  box-sizing: border-box;
  border-radius: 13.94px;
  background: #ecf0f3;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 500;
    color: #121212;
    text-align: center;
    word-break: keep-all;
  }

  > .item.date {
    white-space: pre-line;
    line-height: 1.3;
  }

  > .item.pub > span {
    padding: 6px 10px;
    border-radius: 8px;
    background: #373636;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .item.nickname > span {
    padding: 6px 10px;
    border-radius: 8px;
    background: #b7b7b7;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const EmptyMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #969696;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
`;

export const PaginationBox = styled.div`
  width: 100%;
  display: flex;
  padding-top: 16px;
`;
